module.exports = __webpack_public_path__ + "static/media/bengaliName.8db116b3.png";